import React, { ReactElement } from 'react';
import Header from '../../components/Header';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

export default function DiagnosisIntroPage(): ReactElement {
	const navigate = useNavigate();
	return (
		<Layout>
			<Header />
			<Section>
				<PagesButtons>
					<PagesButton onClick={() => navigate('/diagnosis/item/1')}>
						<img src="/icons/mainIcons/scalp.png" alt="test icon" width="35" />
						<PagesButtonText>내 두피상태 진단 (1분)</PagesButtonText>
					</PagesButton>
					<PagesButton onClick={() => navigate('/diagnosis/item/5')}>
						<img src="/icons/mainIcons/puzzle.png" alt="test icon" width="35" />
						<PagesButtonText>탈모 MBTI (3분)</PagesButtonText>
					</PagesButton>
					<PagesButton onClick={() => navigate('/diagnosis/item/4')}>
						<img src="/icons/mainIcons/ai.png" alt="test icon" width="35" />
						<PagesButtonText>바야바즈 두피 면적 진단</PagesButtonText>
					</PagesButton>
				</PagesButtons>
				<BackgroundImage src="/main-bg.png" alt="" />
			</Section>
		</Layout>
	);
}

const Layout = styled.div`
	width: 100vw; /* 화면 너비에 맞춤 */
	height: 100vh; /* 화면 높이에 맞춤 */
	overflow-x: hidden; /* 좌우 스크롤 방지 */
`;

const Section = styled.div`
	width: 100%;
	height: 100dvh;
	display: flex;
	align-items: center;
	padding: 0 4rem;
	position: relative;
	box-sizing: border-box; /* padding 포함 */

	@media (max-width: 768px) {
		flex-direction: column;
		padding: 0 2rem;
		margin-top: 100px;
	}
`;

const BackgroundImage = styled.img`
	height: 80%;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	padding-right: 4rem; /* 오른쪽 패딩 4rem 추가 */

	@media (max-width: 768px) {
		height: auto; /* 찌그러짐 방지 */
		width: 100%; /* 너비를 100%로 설정 */
		position: static;
		transform: none;
		padding-right: 0;
		margin-top: 2rem;
	}
`;

const PagesButtons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	@media (max-width: 768px) {
		gap: 10px;
	}
`;
const PagesButton = styled.div`
	display: flex;
	border-radius: 10px;
	border: solid 1px #ddd;
	height: 48px;
	padding: 30px 40px;
	align-items: center;
	gap: 10px;
	&:hover {
		background-color: #00ff0d1c; /* 원하는 배경색으로 변경 */
		cursor: pointer; /* 마우스 포인터 변경 */
		border: solid 1px #00ff0d5d;
	}

	@media (max-width: 768px) {
		padding: 20px 50px;
		height: auto;
	}
`;
const PagesButtonText = styled.span`
	color: #0d0d0d;
	font-size: 20px;
	user-select: none;

	@media (max-width: 768px) {
		font-size: 16px;
	}
`;
